import React from 'react'
import { Link } from 'react-router-dom'
import { PropTypes } from 'prop-types'
import cx from 'classnames'

import CartImg from '../../assets/cart.svg'
import Loading from '../Loading/Loading'
import './CartButton.css'

const CartButton = ({ to, left, right, type, disabled = false, loading, ...props }) => {
  if (loading) {
    return (
      <button styleName={cx('cartButton', {loading})} type={type} {...props} disabled>
        <Loading />
      </button>
    )
  }
  const buttonContent = (
    <React.Fragment>
      <span>
        <CartImg styleName='image' />
        {left}
      </span>
      {right}
    </React.Fragment>
  )
  if (type || disabled) {
    return (
      <button styleName='cartButton' type={type} disabled={disabled} {...props}>
        {buttonContent}
      </button>
    )
  }
  return (
    <Link styleName='cartButton' to={to} {...props}>
      {buttonContent}
    </Link>
  )
}

CartButton.propTypes = {
  type: PropTypes.oneOf(['submit', 'reset', 'button']),
  to: PropTypes.string,
  left: PropTypes.node.isRequired,
  right: PropTypes.node,
  disabled: PropTypes.bool
}

export default CartButton
